module.exports = __webpack_public_path__ + "img/pre-start.4b679bf1.png";